export { LoadingModule } from './module.component';
